import { render } from "./card.vue?vue&type=template&id=62fe7952&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=62fe7952&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fe7952"]])

export default __exports__